module.exports = __webpack_public_path__ + "img/labelsOrdered.a77bcd05.svg";